import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectService } from 'src/app/Services/project.service';
import {
  formatPasswordResetHistoryRow,
  PasswordResetHistoryRow,
} from 'src/app/utils/employee-status.util';

export type PasswordResetsDialogData = {
  userId: number | string;
  employeeName?: string;
};

@Component({
  selector: 'app-password-resets-dialog',
  templateUrl: './password-resets-dialog.component.html',
  styleUrls: ['./password-resets-dialog.component.css'],
  standalone: false,
})
export class PasswordResetsDialogComponent implements OnInit {
  loading = true;
  error = '';
  rows: PasswordResetHistoryRow[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PasswordResetsDialogData,
    private dialogRef: MatDialogRef<PasswordResetsDialogComponent>,
    private projectService: ProjectService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.projectService.getEmployeePasswordResets(this.data.userId).subscribe({
      next: (response) => {
        this.rows = (response?.events || [])
          .map((row) =>
            formatPasswordResetHistoryRow(row?.at || '', row?.by_name || '', row?.type || 'password_reset')
          )
          .filter((row) => !!row.when);
        this.loading = false;
      },
      error: () => {
        this.error = 'Couldn’t load password reset history.';
        this.loading = false;
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
